import {CWA_STATUS, CLEAR, ERROR} from './action-types';
import cwaServiceApi from '../api/credit-assessment-service-api';
import config from '../../../config';
import {JsonStreamReader} from './reader/json-stream-reader';

export const clearStatus = () => (dispatch) => {
  dispatch({
    type: CLEAR,
  });
};
export const statusSubscribe = (caseId, subscriptionType) => (dispatch) => {
  const url = `${config.cwaServiceUrl}/status/${caseId}/subscribe/${subscriptionType}`;

  return cwaServiceApi
    .statusSubscribe(url)
    .then(async (response) => {
      const streamReader = new JsonStreamReader(response.body.getReader());
      let result = null;
      let timeout = false;

      while ((!result || result?.value?.status !== 'COMPLETE') && !timeout) {
        // eslint-disable-next-line no-await-in-loop
        result = await streamReader.next(false);

        if (result?.value) {
          dispatch({
            type: CWA_STATUS,
            response: result.value,
          });

          timeout = result?.value?.status === 'TIMED_OUT';
        }
      }
      return null;
    })
    .catch((error) => {
      console.log('Error', error);
      dispatch({
        type: ERROR,
      });
    });
};
